// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"category-button_wrapper__ay8GF","active":"category-button_active__7vA0v"};